import { render, staticRenderFns } from "./Cakesmash.vue?vue&type=template&id=a2653680&scoped=true&"
import script from "./Cakesmash.vue?vue&type=script&lang=js&"
export * from "./Cakesmash.vue?vue&type=script&lang=js&"
import style0 from "./Cakesmash.vue?vue&type=style&index=0&id=a2653680&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2653680",
  null
  
)

export default component.exports